<template>
  <CModal
    :title="title"
    :color="color"
    :show.sync="showModal"
    size="lg"
  >
    <CForm id="property_form" method="POST" enctype="multipart/form-data">
      <CInput
        hidden
        :lazy="false"
        :value.sync="$v.form.id.$model"
        name="id"
        id="id"
      />
      <CRow>
        <CCol md="8">
          <CInput
            label="Nombre de la propiedad:"
            :lazy="false"
            :value.sync="$v.form.name.$model"
            name="name"
            id="name"
            :isValid="checkIfValid('name')"
            invalidFeedback="Este campo es requerido."
          />
        </CCol>
        <CCol md="4">
          <CInput
            label="Código:"
            class="input_code"
            :lazy="false"
            :value.sync="$v.form.code.$model"
            name="code"
            id="code"
            placeholder=""
            autocomplete="off",
            disabled readonly
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="4">
          <CSelect
            label="Tipo de activo:"
            :value.sync="$v.form.asset_type_id.$model"
            :options="typesOptions"
            :isValid="checkIfValid('asset_type_id')"
            name="asset_type_id"
            id="asset_type_id"
            invalidFeedback="Este campo es requerido."
          />
        </CCol>
        <CCol md="4">
          <CSelect
            label="Departamento:"
            :value.sync="$v.form.asset_departament_id.$model"
            :options="departamentsOptions"
            :isValid="checkIfValid('asset_departament_id')"
            name="asset_departament_id"
            id="asset_departament_id"
            invalidFeedback="Este campo es requerido."
          />
        </CCol>
        <CCol md="4">
          <CSelect
            label="Situación de la propiedad:"
            :value.sync="$v.form.property_type.$model"
            :options="propertyTypeOptions"
            :isValid="checkIfValid('property_type')"
            name="property_type"
            id="property_type"
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="4">
          <CInput
            label="Predial:"
            :lazy="false"
            :value.sync="$v.form.predial.$model"
            name="predial"
            id="predial"
          />
        </CCol>
        <CCol md="4">
          <CInput
            label="Clave catastral:"
            :lazy="false"
            :value.sync="$v.form.catastral_code.$model"
            name="catastral_code"
            id="catastral_code"
          />
        </CCol>
        <CCol md="4">
          <CInput
            label="Superficie catastral:"
            :lazy="false"
            :value.sync="$v.form.catastral_area.$model"
            name="catastral_area"
            id="catastral_area"
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="12">
          <CInput
            label="Ubicación:"
            :lazy="false"
            :value.sync="$v.form.location.$model"
            name="location"
            id="location"
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="6">
          <CSelect
            label="Tipo de construcción:"
            :value.sync="$v.form.building_status.$model"
            :options="buildingStatusOptions"
            name="building_status"
            id="building_status"
          />
        </CCol>
        <CCol md="6">
          <CInput
            label="Uso de la propiedad:"
            :lazy="false"
            :value.sync="$v.form.use_of_the_property.$model"
            name="use_of_the_property"
            id="use_of_the_property"
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="4">
          <CSelect
            label="Tipo de documento:"
            :value.sync="$v.form.document_type.$model"
            :options="documentTypeOptions"
            name="document_type"
            id="document_type"
          />
        </CCol>
        <CCol md="4">
          <CInput
            label="Documento:"
            :lazy="false"
            :value.sync="$v.form.document.$model"
            name="document"
            id="document"
          />
        </CCol>
        <CCol md="4">
          <CInput
            label="Instrumento legal:"
            :lazy="false"
            :value.sync="$v.form.legal_instrument.$model"
            name="legal_instrument"
            id="legal_instrument"
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="6">
          <CInput
            label="Imagen 1:"
            :lazy="false"
            :value.sync="$v.form.image.$model"
            type="file"
            accept=".jpg,.jpeg,.png;capture=camera"
            name="image"
            id="image"
          />
        </CCol>
        <CCol md="6">
          <CInput
            label="Imagen 2:"
            :lazy="false"
            :value.sync="$v.form.image2.$model"
            type="file"
            accept=".jpg,.jpeg,.png;capture=camera"
            name="image2"
            id="image2"
          />
        </CCol>
      </CRow>

      <CRow>
        <CCol md="6">
          <CInput
            label="Imagen 3:"
            :lazy="false"
            :value.sync="$v.form.image3.$model"
            type="file"
            accept=".jpg,.jpeg,.png;capture=camera"
            name="image3"
            id="image3"
          />
        </CCol>
        <CCol md="6">
          <CInput
            label="Imagen 4:"
            :lazy="false"
            :value.sync="$v.form.image4.$model"
            type="file"
            accept=".jpg,.jpeg,.png;capture=camera"
            name="image4"
            id="image4"
          />
        </CCol>
      </CRow>

        <CRow>
            <CCol md="12">
                <CInput
                    label="Observaciones:"
                    :lazy="false"
                    :value.sync="$v.form.observations.$model"
                    name="observations"
                    id="observations"
                    placeholder=""
                    autocomplete="given-observations"
                />
            </CCol>            
        </CRow>
        <CRow v-show="assignationEnabled">         
            <CCol md="12">
            <br /><h5>PERSONA ASIGNADA (RESGUARDO)</h5><br />
            </CCol>                                                             
        </CRow>
        <CRow v-show="assignationEnabled">         
            <CCol md="6">
            <div role="group" class="form-group">
                <label> Fecha de Asignación:</label>
                <v-date-picker
                class="date-picker"
                v-model="$v.form.asset_date.$model"
                locale="es-MX" size="sm"
                />
            </div>
            </CCol>                   
            <CCol md="6">
            <CSelect
                label="Persona Asignada:"
                :value.sync="$v.form.asset_person_id.$model"
                :options="personsOptions"
                invalidFeedback="Este campo es requerido."
                />                            
            </CCol>                                                             
        </CRow>
        <CRow v-show="assignationEnabled">
            <CCol md="12">
            <CInput
                label="Motivo o razón:"
                :lazy="false"
                :value.sync="$v.form.asset_description.$model"
                placeholder=""
                autocomplete="given-description"
                invalidFeedback="Este campo es requerido."
            />
            <CInput
            :lazy="false"
            :value.sync="$v.form.asset_id.$model"
            hidden
            />
            </CCol>            
        </CRow>
    </CForm>
    <template #footer>
        <CButton v-if="!assignationEnabled && form.id == 0" style="position: absolute; left: 10px;" @click="assignationEnabled = true;" color="warning">Asignar Propiedad</CButton>
        <CButton @click="closeModal" color="secondary">Cancelar</CButton>
        <CButton @click="submitForm" :color="color">Aceptar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, minValue, helpers } from "vuelidate/lib/validators"
import ws_typ from '../../services/asset_types'
import ws_dep from '../../services/asset_departaments'
import ws_per from '../../services/asset_persons'
import store from '../../store'

import { DatePicker } from 'v-calendar'
import moment from 'moment';
import moment_timezone from 'moment-timezone'

export default {
  name: 'PropertyModal',
  mixins: [validationMixin],
  components: {
    'v-date-picker': DatePicker
  },
  data () {
    return {
      showModal: false,
      title: 'Nueva Propiedad',
      color: 'info',
      isEdit: false,
      form: this.getEmptyForm(),
      typesOptions: [],
      departamentsOptions: [],
      personsOptions: [],
      propertyTypeOptions: [
        { value: 'Propio', label: 'Propio' },
        { value: 'Arrendamiento', label: 'Arrendamiento' },
        { value: 'Arrendatario', label: 'Arrendatario' },
        { value: 'Otro', label: 'Otro' }
      ],
      documentTypeOptions: [
        { value: 'Escritura', label: 'Escritura' },
        { value: 'Contrato', label: 'Contrato' },
        { value: 'Otros', label: 'Otros' }
      ],
      buildingStatusOptions: [
        { value: 'Terreno', label: 'Terreno' },
        { value: 'Edificio', label: 'Edificio' },
        { value: 'Otros', label: 'Otros' }
      ],
      assignationEnabled: false,
    }
  },
  validations: {
    form: {
      id: {},
      code: {},
      name: { required },
      asset_type_id: { required, minValue: minValue(1) },
      asset_departament_id: { required, minValue: minValue(1) },
      property_type: {},
      predial: {},
      catastral_code: {},
      catastral_area: {},
      location: {},
      building_status: {},
      use_of_the_property: {},
      document_type: {},
      document: {},
      legal_instrument: {},
      image: {},
      image2: {},
      image3: {},
      image4: {},
      observations: {},
      asset_person_id: {},
      asset_id: {},
      asset_date: {},
      asset_description: {},
      is_active: {},
      is_trash: {}
    }
  },
  methods: {
    getEmptyForm () {
      return {
        id: 0,
        code: '',
        name: '',
        asset_type_id: 0,
        asset_departament_id: 0,
        property_type: 'Otro',
        predial: '',
        catastral_code: '',
        catastral_area: '',
        location: '',
        building_status: 'Otros',
        use_of_the_property: '',
        document_type: 'Escritura',
        document: '',
        legal_instrument: '',
        image: '',
        image2: '',
        image3: '',
        image4: '',
        observations: '',
        asset_description: '',
        asset_id: '',
        asset_date: '',
        asset_person_id: 0,
        is_active: true,
        is_trash: false
      }
    },
    async openModal (item = null) {
      this.loading()
      try {
        await this.loadSelects()

        if (item) {
          this.isEdit = true
          this.title = 'Editar Propiedad'
          this.color = 'warning'
          this.form = {
            id: item.id,
            code: item.code,
            name: item.name,
            asset_type_id: item.asset_type_id || 0,
            asset_departament_id: item.asset_departament_id || 0,
            property_type: item.property_type || 'Otro',
            predial: item.predial || '',
            catastral_code: item.catastral_code || '',
            catastral_area: item.catastral_area || '',
            location: item.location || '',
            building_status: item.building_status || 'Otros',
            use_of_the_property: item.use_of_the_property || '',
            document_type: item.document_type || 'Escritura',
            document: item.document || '',
            legal_instrument: item.legal_instrument || '',
            image: '',
            image2: '',
            image3: '',
            image4: '',
            observations: item.observations || '',
            asset_person_id: item.asset_person_id || 0,
            asset_date: item.asset_date || '',
            asset_description: item.asset_description || '',
            is_active: !!item.is_active,
            is_trash: !!item.is_trash
          }
        } else {
          this.isEdit = false
          this.title = 'Nueva Propiedad'
          this.color = 'info'
          this.form = this.getEmptyForm();
          this.assignationEnabled = false;
        }

        this.$v.$reset()
        this.showModal = true
      } finally {
        this.loaded()
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    async loadSelects () {
      const responseTyp = await ws_typ.get()
      if (responseTyp.type === 'success') {
        this.typesOptions = responseTyp.data.map(t => ({ value: t.id, label: t.name }))
      }

      const responseDep = await ws_dep.get()
      if (responseDep.type === 'success') {
        this.departamentsOptions = responseDep.data.map(d => ({ value: d.id, label: d.name }))
      }

      const responsePer = await ws_per.get()
      if (responsePer.type === 'success') {
        this.personsOptions = [{ value: 0, label: 'Sin responsable' }].concat(
          responsePer.data.map(p => ({ value: p.id, label: p.name }))
        )
      }
    },
    submitForm () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      const form = document.getElementById('property_form')
      const formData = new FormData(form)

      if (this.form.asset_date) {
        formData.set('asset_date', moment(this.form.asset_date).format('YYYY-MM-DD'))
      }

      formData.set('asset_person_id', this.form.asset_person_id || '')
      formData.set('asset_description', this.form.asset_description || '')

      if (this.isEdit) {
        this.$emit('update', formData)
      } else {
        this.$emit('store', formData)
      }
      this.closeModal()
    },
    checkIfValid (field) {
      const control = this.$v.form[field]
      if (!control) return null
      return !control.$dirty ? null : !control.$invalid
    },
    loading () {
      store.commit('loading')
    },
    loaded () {
      store.commit('loaded')
    }
  }
}
</script>

<style>
.input_code .form-control {
  text-align: center;
}
</style>
